// queries/useGetAdminLoras.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_LORAS_ADMIN } from "api"; // Assuming you have this configured

interface Lora {
  name: string;
  title: string;
  alias?: string;
  path?: string;
  image_url: string;
  is_nsfw: boolean;
  metadata?: {
    [key: string]: any;
    ss_output_name?: string;
  };
  trigger_words?: string;
}

interface LoraResponse {
  loras: any;
  total_loras: number;
}


const fetchAdminLoras = async (): Promise<LoraResponse> => {
  return fetch(GET_LORAS_ADMIN);
};

export const useGetAdminLoras = () => {
  return useQuery<LoraResponse, Error>({
    queryKey: ["adminLoras"],
    queryFn: fetchAdminLoras,
  });
};

export default useGetAdminLoras;